import { privateAxios } from 'services/api/privateAxios';

export const editCustomerAddress = (data, id) =>
  privateAxios({
    method: 'put',
    url: `/address/${id}`,
    data,
  });
